


export const NewsSection=()=>{
    
    

    return(
        <div className="news-section">
            <div className="news-section_header">
                <h1>Recent news</h1>
            </div>
            <div className="news-section_placeholder">
                {[1,2,3].map((p,i)=>
                    <div key={i} className={`news-section_block ${i==0?'bigger':''}`}>
                        <div className="news-section_block-img -ibg">
                            <img src={require('../../../static/image-news-1.jpg')}/>
                        </div>
                        <div className="news-section_block-body">
                            <h1>
                                How to Build Climate Change-Resilient Infrastructure
                            </h1>
                            <div className="news-section_block-data">
                                <p>Industry News</p>
                                <div className="news-section_block-data-divider"></div>
                                <p>June 24, 2020</p>
                                <div className="news-section_block-data-divider"></div>
                                <p>4 comments</p>
                            </div>
                            <div className="news-section_block-title">
                                Ipsum aliquet nisi, hendrerit rhoncus quam tortor, maecenas faucibus. Tincidunt aliquet sit vel, venenatis nulla. Integer bibendum turpis convallis enim, nibh convallis...
                            </div>
                        </div>
                    </div>
                )}
                
                
                <div className="news-section_block">

                </div>
            </div>
        </div>
    )
}